import { Routes } from "@angular/router";
import * as signUpSettings from '@auth/sign-up/sign-up.settings.json';
import { PAGE_SETTINGS } from '@shared/components/page-layout/page-layout.types';

export const guestsRoute: Routes = [
   { 
        path: 'forgot-password', 
        loadChildren: () => import('@auth/forgot-password/forgot-password.routing').then(m => m.authForgotPasswordRoutes) 
    },
    { 
        path: 'reset-password',
        loadChildren: () => import('@auth/reset-password/reset-password.routing').then(m => m.authResetPasswordRoutes) 
    },
    { 
        path: 'sign-in', 
        loadChildren: () => import('@auth/sign-in/sign-in.routing').then(m => m.authSignInRoutes) 
    },
    { 
        path: 'sign-up',
        providers: [
            {
                provide: PAGE_SETTINGS,
                useValue: signUpSettings
            },
        ],
        loadChildren: () => import('@auth/sign-up/sign-up.routing').then(m => m.authSignUpRoutes) 
    },
    { 
        path: 'rating',
        loadChildren: () => import('@shared/components/job-checkout/job-rating/job-rating.routing').then(m => m.jobRatingRoutes)
    },
    { 
        path: 'public', 
        loadChildren: () => import('@public/public.routing').then(m => m.publicRoutes) 
    },
];